/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isProCodeComponentType(desc) {
  return 'package' in desc;
}